import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';

const ResolvedDonutChart = ({ resolved, total, color = '#00B8FF', size = 180 }) => {
    const percent = total > 0 ? Math.round((resolved / total) * 100) : 0;
    // Data for the background (full ring) and the resolved arc
    const bgData = [{ value: 1 }];
    const resolvedData = [
        { value: resolved },
        { value: total - resolved }
    ];
    // console.log('percent', resolved)
    return (
        <PieChart width={size} height={size}>
            {/* Background ring (thin) */}
            <Pie
                data={bgData}
                dataKey="value"
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={75}
                startAngle={90}
                endAngle={-270}
                fill="#e4e4e4"
                stroke="none"
                isAnimationActive={false}
            />
            {/* Resolved arc (thick) */}
            <Pie
                data={resolvedData}
                dataKey="value"
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={75}
                startAngle={90}
                endAngle={-270}
                stroke="none"
                isAnimationActive={false}
            >
                <Cell fill={color} />
                <Cell fill="transparent" />
            </Pie>
            {/* Centered label */}
            <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize="28"
                fill={color}
                fontWeight="bold"
            >
                {percent}%
            </text>
        </PieChart>
    );
};

export default ResolvedDonutChart; 